module.exports = __webpack_public_path__ + "img/soundfield_3.cd16f7ba.jpg";